/* dz-pack.js — pack « 1 pull ou les 2 » posé SUR la fiche produit réelle du pull demi-zip (StefLuxe, chantier stefluxe-pack-demizip, 29/10/2026).
   Blocs du gabarit product.demizip : dz-offre (#dz-pack : offre 1 / 2 / 3 pulls + données), dz-tailles (#dz-tailles : calculateur, grille du client),
   dz-pull2 (#dz-pulls : couleur + taille des pulls 2 et 3), dz-recap (#dz-recap : sac cadeau, total, erreurs). Le pull 1 = le sélecteur de variantes
   NATIF du thème ; le bouton = le bouton NATIF « Ajouter au panier » (la barre fixe du thème le clique).
   Deux chemins : 1 pull sans sac ⇒ rien n'est intercepté, le thème ajoute au panier comme sur toute fiche (tiroir) ; ≥ 2 pulls ou sac ⇒ l'envoi du
   formulaire natif est intercepté (phase de capture), les lignes du pack sont posées par /cart/add.js (propriété _pack), puis /discount/<code> ⇒ checkout.
   Taille du pull 1 : le thème en coche une d'office ; elle ne compte qu'une fois touchée par le client — d'ici là, l'envoi est retenu (les deux chemins).
   Releasit (formulaire COD de la boutique, 30/10) : son bouton ne commande que la variante du formulaire natif — taille du pull 1 pas choisie ou pack
   ⇒ intercepté comme le bouton natif (le pack garde son chemin), 1 pull sans sac ⇒ Releasit ouvre son formulaire.
   Options lues par leur NOM (option1/2 résolue par le bloc Liquid, fieldset natif par sa légende), jamais par leur position (règle 43).
   Une seule exécution même si le script est inclus deux fois ; fonctions pures exposées sur window.DZ (tests/logique.test.mjs). */
(function () {
  'use strict';
  var DZ = window.DZ = window.DZ || {};
  if (DZ.charge) return;
  DZ.charge = true;
  var ETIQUETTE = 'demizip';
  // Boutons de commande de Releasit (relevés dans son script, 30/10) : bouton de la fiche, bloc d'app, bouton flottant (même id).
  DZ.RSI = '#rsi_buy_now_button, ._rsi-buy-now-button, ._rsi-buy-now-button-app-block-hook button';
  // Navigation (remplaçable par un test) — jamais appelée tant que /cart/add.js n'a pas répondu 200.
  DZ.aller = DZ.aller || function (url) { window.location.href = url; };

  /* <logique> — fonctions pures, testées telles quelles */
  DZ.nombre = function (s) { var t = String(s == null ? '' : s).replace(',', '.').replace(/[^0-9.]/g, ''); return t ? parseFloat(t) : NaN; };
  // « 1,78 » ou « 1.78 » (mètres) → 178 ; « 178 » → 178
  DZ.hauteur = function (s) { var n = DZ.nombre(s); if (n > 0 && n < 3) n = n * 100; return isNaN(n) ? NaN : Math.round(n); };
  // Rang de la taille dont la plage [min, max] contient val : deux plages qui se chevauchent ⇒ la plus grande ; entre deux plages ⇒ celle du dessus ;
  // sous la plus petite ⇒ la plus petite ; au-dessus de la plus grande ⇒ -1 (hors grille) ; aucune donnée pour cette mesure ⇒ null.
  DZ.rang = function (T, cle, val) {
    var dedans = -1, prem = -1, der = -1, i, r;
    for (i = 0; i < T.length; i++) { r = T[i][cle]; if (!r || r.length !== 2) continue; if (prem < 0) prem = i; der = i; if (val >= r[0] && val <= r[1]) dedans = i; }
    if (prem < 0) return null;
    if (dedans >= 0) return dedans;
    if (val < T[prem][cle][0]) return prem;
    if (val > T[der][cle][1]) return -1;
    for (i = prem; i <= der; i++) { r = T[i][cle]; if (r && r.length === 2 && val < r[0]) return i; }
    return -1;
  };
  // Conseil = la plus grande des deux tailles (hauteur, poids) : « entre deux, prends celle du dessus ».
  DZ.conseil = function (guide, h, w) {
    var T = (guide && guide.tailles) || [];
    if (!T.length) return { etat: 'sans_grille' };
    if (guide.methode === 'poitrine') return DZ.conseilPoitrine(guide, h, w);
    var a = isNaN(w) ? null : DZ.rang(T, 'poids_kg', w), b = isNaN(h) ? null : DZ.rang(T, 'hauteur_cm', h);
    if (a === -1 || b === -1) return { etat: 'hors_grille', taille: T[T.length - 1].taille };
    if (a === null && b === null) return { etat: 'incomplet' };
    var i = Math.max(a === null ? -1 : a, b === null ? -1 : b);
    return { etat: 'ok', taille: T[i].taille };
  };
  // Grille « poitrine » (taille indicative tant que la boutique n'a pas donné la sienne) : tour de poitrine du CORPS estimé
  // k + poids × kg + taille × cm + marge (modèle et marge : scripts/construire-guide-poitrine.py), classé dans les plages [min, max[ des tailles ;
  // plus grand que 95 % des hommes de cette taille (grand_cm) ⇒ la taille du dessus est proposée pour la longueur (plus_long).
  DZ.conseilPoitrine = function (guide, h, w) {
    var T = guide.tailles, m = guide.modele || {}, der = T.length - 1, i = 0, p, r;
    if (isNaN(h) || isNaN(w)) return { etat: 'incomplet' };
    p = m.k + m.poids * w + m.taille * h + (m.marge_cm || 0);
    if (!isFinite(p) || !T[der].poitrine_cm) return { etat: 'sans_grille' };
    if (p >= T[der].poitrine_cm[1]) return { etat: 'hors_grille', taille: T[der].taille };
    while (i < der && T[i].poitrine_cm && p >= T[i].poitrine_cm[1]) i++;
    r = { etat: 'ok', taille: T[i].taille };
    if (T[i].grand_cm && h > T[i].grand_cm && i < der) r.plus_long = T[i + 1].taille;
    return r;
  };
  DZ.montant = function (c) { var n = Math.round(c), ent = Math.floor(n / 100), dec = n % 100, s = String(ent).replace(/\B(?=(\d{3})+(?!\d))/g, ','); return dec ? s + '.' + (dec < 10 ? '0' : '') + dec : s; };
  DZ.prixOffre = function (n, prix1, prix2, prix3, port) { return n === 1 ? prix1 + port : n === 2 ? prix2 : prix3; };
  // 1 pull sans sac : chemin NATIF du thème (ajout au panier, tiroir) ; sinon le pack pose ses lignes puis va au checkout.
  DZ.chemin = function (n, sac) { return n >= 2 || sac ? 'pack' : 'natif'; };
  // ≥ 2 pulls ⇒ le code « livraison offerte » s'applique par /discount/<code>, puis checkout ; sinon checkout direct.
  DZ.destination = function (n, code, racine) { var r = racine || '/'; return n >= 2 && code ? r + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(r + 'checkout') : r + 'checkout'; };
  // Lignes à poser : les pulls (deux fois la même variante = quantité 2) puis le sac ; chaque ligne porte _pack (cachée au checkout, lisible dans la commande).
  DZ.lignes = function (variantes, sacId, etiquette) {
    var items = [];
    (variantes || []).forEach(function (v) { var ex = null; items.forEach(function (x) { if (x.id === v.id) ex = x; }); if (ex) ex.quantity += 1; else items.push({ id: v.id, quantity: 1, properties: { _pack: etiquette } }); });
    if (sacId) items.push({ id: sacId, quantity: 1, properties: { _pack: etiquette } });
    return items;
  };
  // Lignes du panier à retirer avant l'ajout : toutes celles du pull (le pack définit la commande de CE produit) ; le sac seulement s'il vient de ce pack
  // (propriété _pack) — un sac pris avec un autre produit reste au panier.
  DZ.lignesARetirer = function (items, pid, sacPid, etiquette) {
    return (items || []).filter(function (it) { return it.product_id === pid || (!!sacPid && it.product_id === sacPid && !!it.properties && it.properties._pack === etiquette); }).map(function (it) { return it.key; });
  };
  // Fieldset d'une option par son NOM (la légende commence par le nom de l'option), jamais par sa position.
  DZ.fieldsetParNom = function (conteneur, nom) {
    if (!conteneur || !nom) return null;
    var fs = conteneur.querySelectorAll('fieldset'), n = String(nom).trim().toLowerCase(), i, l;
    for (i = 0; i < fs.length; i++) { l = fs[i].querySelector('legend'); if (l && l.textContent.trim().toLowerCase().indexOf(n) === 0) return fs[i]; }
    return null;
  };
  // Message d'un envoi incomplet, pull par pull : manque = [{ k: 1 }, { k: 2, c: true }] (c = la couleur manque aussi ; le pull 1 n'attend que sa
  // taille, sa couleur est celle de la fiche). Offre d'un seul pull ⇒ « Choisis ta taille. »
  DZ.messageManque = function (n, manque) {
    var t = [], ct = [], parts = [];
    if (!manque || !manque.length) return '';
    if (n === 1) return 'Choisis ta taille.';
    manque.forEach(function (m) { (m.c ? ct : t).push('pull ' + m.k); });
    if (t.length) parts.push('la taille du ' + t.join(' et du '));
    if (ct.length) parts.push('la couleur et la taille du ' + ct.join(' et du '));
    return 'Choisis ' + parts.join(', puis ') + '.';
  };
  // Taille du pull 1 « à choisir » (html[data-dz-t1]) : celle que le thème a cochée d'office se montre comme les autres (pastille rangée, couleurs de
  // repos) ; « manque » (envoi tenté sans taille) = légende en rouge. Fieldset désigné par le NOM de l'option : boutons « <nom>-<bloc>-<produit> ».
  DZ.cssTaille1 = function (pid, nom) {
    var fs = 'variant-picker[data-product-id="' + pid + '"] fieldset:has(input[type="radio"][name^="' + String(nom).replace(/["\\]/g, '\\$&') + '-"])';
    function deux(s) { return 'html[data-dz-t1="a-choisir"] ' + fs + s + ',\nhtml[data-dz-t1="manque"] ' + fs + s; }
    return deux(' .variant-option__button-label') + ' { --pill-offset: calc(100% + 1px); --clip: 0 0 0 100%; }\n' +
      deux(' .variant-option__button-label:has(:checked):not(:has([data-option-available="false"]))') + ' { color: var(--color-variant-text); border-color: var(--color-variant-border); }\n' +
      deux(' .variant-option__button-label:has(:checked)::before') + ' { border-color: var(--color-variant-border); }\n' +
      'html[data-dz-t1="manque"] ' + fs + ' legend { color: #8a1c1c; }\n';
  };
  /* </logique> */

  function radioParValeur(conteneur, valeur) {
    if (!conteneur) return null;
    var rs = conteneur.querySelectorAll('input[type="radio"]'), i;
    for (i = 0; i < rs.length; i++) if (rs[i].value === valeur) return rs[i];
    return null;
  }

  function init() {
    var root = document.getElementById('dz-pack');
    if (!root || root.dataset.pret) return;
    root.dataset.pret = '1';
    var pid = +root.dataset.pid, MAX = +root.dataset.max || 1;
    var pulls = document.getElementById('dz-pulls'), recap = document.getElementById('dz-recap'), tailles = document.getElementById('dz-tailles');
    var composant = document.querySelector('product-form-component[data-product-id="' + pid + '"]');
    var form = composant ? composant.querySelector('form') : null;
    var btn = composant ? composant.querySelector('[ref="addToCartButton"]') : null;
    var picker = document.querySelector('variant-picker[data-product-id="' + pid + '"]');
    if (!form || !btn) return; // sans formulaire natif, rien à régler : la fiche reste celle du thème
    var R = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var variants = JSON.parse(root.querySelector('.dz-variants').textContent);
    var FORMAT = ''; try { FORMAT = JSON.parse(root.querySelector('.dz-format').textContent) || ''; } catch (e) { FORMAT = ''; }
    function fmt(c) { var m = DZ.montant(c); return /amount/.test(FORMAT) ? FORMAT.replace(/<[^>]*>/g, '').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, m).trim() : m + ' dh'; }
    var oc = root.dataset.oc, ot = root.dataset.ot, NOM_T = root.dataset.nomTaille;
    var prix1 = +root.dataset.prix1, prix2 = +root.dataset.prix2, prix3 = +root.dataset.prix3, port = +root.dataset.livraison || 0;
    var sacPrix = recap ? (+recap.dataset.sacPrix || 0) : 0;
    var couleurs = [], tailleListe = [];
    variants.forEach(function (v) { if (couleurs.indexOf(v[oc]) < 0) couleurs.push(v[oc]); if (tailleListe.indexOf(v[ot]) < 0) tailleListe.push(v[ot]); });
    function variante(c, t) { for (var i = 0; i < variants.length; i++) if (variants[i][oc] === c && variants[i][ot] === t) return variants[i]; return null; }
    function dispo(c, t) { var v = variante(c, t); return !!(v && v.available); }
    function couleurDispo(c) { return tailleListe.some(function (t) { return dispo(c, t); }); }
    function tailleDispo(t) { return couleurs.some(function (c) { return dispo(c, t); }); }
    // Pull 1 = la variante du formulaire natif (le thème met input[name=id] à jour à chaque changement d'option).
    function sel1() { var inp = form.querySelector('input[name="id"]'), id = inp ? +inp.value : 0; for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i]; return null; }
    function offre() { var r = root.querySelector('input[name="dz-offre"]:checked'); return r ? Math.min(Math.max(+r.value || 1, 1), MAX) : 1; }
    function sacCoche() { var s = recap && recap.querySelector('input[name="dz-sac"]'); return !!(s && s.checked); }
    function pull(k) { return pulls ? pulls.querySelector('.dz-pull[data-pull="' + k + '"]') : null; }
    function radios(k, opt) { var p = pull(k); return p ? Array.prototype.slice.call(p.querySelectorAll('input[name="dz-' + k + '-' + opt + '"]')) : []; }
    function choisi(k, opt) { var p = pull(k), r = p && p.querySelector('input[name="dz-' + k + '-' + opt + '"]:checked'); return r ? r.value : null; }
    function sel(k) { return { c: choisi(k, 'couleur'), t: choisi(k, 'taille') }; }
    function note(k, m) { var p = pull(k), n = p && p.querySelector('.dz-pull-note'); if (n) { n.textContent = m; n.hidden = !m; } }
    function cocher(r, oui) { r.checked = oui; r.setAttribute('data-current-checked', oui ? 'true' : 'false'); }
    function marquer(r, ok) { r.setAttribute('data-option-available', ok ? 'true' : 'false'); r.setAttribute('aria-disabled', ok ? 'false' : 'true'); }
    // Pull 1 = le sélecteur NATIF : le thème y coche d'office une taille (variante « sélectionnée ou première disponible »). En paiement à la livraison,
    // une taille que le client n'a pas choisie = un colis refusé : tant qu'il n'a touché aucune taille du sélecteur natif (clic, clavier, calculateur),
    // elle se montre NON choisie (DZ.cssTaille1) et l'envoi est retenu. État sur <html> : le thème re-rend le sélecteur (morph) et retirerait une marque
    // posée dessus. Sans boutons de taille « <nom>-… » (liste déroulante, option renommée) : rien n'est armé, jamais un client bloqué.
    function estTaille1(el) { return !!(el && el.type === 'radio' && NOM_T && String(el.name).indexOf(NOM_T + '-') === 0 && el.closest && el.closest('variant-picker[data-product-id="' + pid + '"]')); }
    function fsTaille1() { return DZ.fieldsetParNom(document.querySelector('variant-picker[data-product-id="' + pid + '"]'), NOM_T); }
    var fsT1 = fsTaille1(), t1 = !(fsT1 && Array.prototype.some.call(fsT1.querySelectorAll('input[type="radio"]'), estTaille1));
    var noteT1 = pulls && pulls.querySelector('.dz-t1-note');
    function etatT1(v) { document.documentElement.setAttribute('data-dz-t1', v); }
    function choisirT1() { if (t1) return; t1 = true; etatT1('choisie'); if (noteT1) { noteT1.textContent = ''; noteT1.hidden = true; } }
    if (!t1) {
      etatT1('a-choisir');
      var styleT1 = document.createElement('style'); styleT1.id = 'dz-t1-style'; styleT1.textContent = DZ.cssTaille1(pid, NOM_T); document.head.appendChild(styleT1);
      ['click', 'change'].forEach(function (ev) { document.addEventListener(ev, function (e) { if (estTaille1(e.target)) choisirT1(); }, true); });
    }
    // Disponibilité affichée comme le thème (barrée) : couleur = au moins une taille ; taille = dans la couleur choisie, sinon dans au moins une couleur.
    function majDispo(k) {
      var s = sel(k), p = pull(k);
      radios(k, 'couleur').forEach(function (r) { marquer(r, couleurDispo(r.value)); });
      radios(k, 'taille').forEach(function (r) { marquer(r, s.c ? dispo(s.c, r.value) : tailleDispo(r.value)); });
      if (p) { var zc = p.querySelector('[data-choisi="couleur"]'), zt = p.querySelector('[data-choisi="taille"]'); if (zc) zc.textContent = s.c || ''; if (zt) zt.textContent = s.t || ''; }
    }
    // Présélection : une autre couleur disponible que celle du pull 1 (puis la suivante pour le pull 3) ; la TAILLE n'est jamais présélectionnée :
    // en paiement à la livraison, une mauvaise taille = un colis refusé.
    function preselection() {
      var v1 = sel1(), ordre = couleurs.filter(couleurDispo), base = v1 ? ordre.indexOf(v1[oc]) : -1, k, r;
      if (!ordre.length) return;
      for (k = 2; k <= MAX; k++) {
        if (sel(k).c) continue;
        r = radioParValeur(pull(k), ordre[((base + k - 1) % ordre.length + ordre.length) % ordre.length]);
        if (r && r.name === 'dz-' + k + '-couleur') cocher(r, true);
        majDispo(k);
      }
    }
    function erreur(m) { var e = recap && recap.querySelector('.dz-erreur'); if (e) { e.textContent = m; e.hidden = !m; } }
    function total() {
      var n = offre(), t = DZ.prixOffre(n, prix1, prix2, prix3, port) + (sacCoche() ? sacPrix : 0), k, p;
      for (k = 2; k <= 3; k++) { p = pull(k); if (p) p.hidden = k > n; }
      if (recap) {
        var tn = recap.querySelector('.dz-total-n'), ts = recap.querySelector('.dz-total-s');
        if (tn) tn.textContent = fmt(t);
        if (ts) ts.textContent = (n >= 2 ? 'livraison offerte' : port > 0 ? 'livraison ' + fmt(port) + ' comprise' : 'livraison en plus') + ' · paiement à la livraison';
      }
      etiquette();
    }
    // Libellé du bouton natif (et de la barre fixe) : « Commander le pack » dès que le pack prend la main, le libellé du thème sinon
    // (et toujours celui du thème quand il a désactivé le bouton : « Épuisé » reste « Épuisé »).
    var occupe = false, etaitDesactive = false;
    function etiquette() {
      var n = offre(), pack = DZ.chemin(n, sacCoche()) === 'pack';
      [btn].concat(Array.prototype.slice.call(document.querySelectorAll('sticky-add-to-cart [ref="addToCartButton"]'))).forEach(function (b) {
        var s = b.querySelector('.add-to-cart-text__content > span');
        if (!s) return;
        if (!s.dataset.dzLibelle) s.dataset.dzLibelle = s.textContent;
        s.textContent = occupe ? 'Un instant…' : b.disabled ? s.dataset.dzLibelle : pack ? (n >= 2 ? 'Commander le pack' : 'Commander') : s.dataset.dzLibelle;
      });
    }
    // html.dz-occupe : le bouton Releasit (seul visible quand il est là, dz-pack.css) attend lui aussi et affiche « Un instant… ».
    function occuper(oui) {
      if (oui) etaitDesactive = btn.disabled;
      occupe = oui; btn.disabled = oui ? true : etaitDesactive; btn.setAttribute('aria-busy', oui ? 'true' : 'false');
      document.documentElement.classList.toggle('dz-occupe', oui); etiquette();
    }
    // Retour arrière depuis le checkout, double clic : les lignes déjà posées par ce pack sont retirées avant l'ajout (sinon « les 2 » deviennent 4) ;
    // les autres produits du panier ne bougent pas. Best effort : n'empêche jamais la commande.
    function viderPack() {
      var sacPid = recap ? (+recap.dataset.sacPid || 0) : 0;
      return fetch(R + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          return DZ.lignesARetirer(cart.items, pid, sacPid, ETIQUETTE).reduce(function (pr, c) {
            return pr.then(function () { return fetch(R + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: c, quantity: 0 }) }); });
          }, Promise.resolve());
        })
        .catch(function () {});
    }
    function commander(n, sac) {
      var v1 = sel1(), variantes = [], manque = [], premier = null, k, s, v, p;
      if (!v1 || !v1.available) { erreur('Choisis la couleur et la taille de ton pull.'); return; }
      variantes.push(v1);
      if (!t1) {
        manque.push({ k: 1 }); premier = fsTaille1(); etatT1('manque');
        if (noteT1) { noteT1.textContent = DZ.messageManque(n, [{ k: 1 }]); noteT1.hidden = false; }
      }
      for (k = 2; k <= n; k++) {
        s = sel(k); p = pull(k); v = s.c && s.t ? variante(s.c, s.t) : null;
        if (!v || !v.available) { manque.push({ k: k, c: !s.c }); if (p) { p.classList.add('dz-pull--manque'); if (!premier) premier = p; } continue; }
        if (p) p.classList.remove('dz-pull--manque');
        variantes.push(v);
      }
      if (manque.length) {
        erreur(DZ.messageManque(n, manque));
        if (premier && premier.scrollIntoView) premier.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      var items = DZ.lignes(variantes, sac && recap ? +recap.dataset.sacId : 0, ETIQUETTE);
      erreur(''); occuper(true);
      viderPack()
        .then(function () { return fetch(R + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) }); })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, b: b }; }); })
        .then(function (x) {
          if (!x.ok) throw new Error((x.b && (x.b.description || x.b.message)) || 'Erreur');
          DZ.aller(DZ.destination(n, root.dataset.code, R));
        })
        .catch(function (e) {
          occuper(false);
          erreur(/stock|inventory|disponible|available|quantit/i.test(String(e && e.message)) ? 'Il ne reste pas assez de pièces dans cette couleur et cette taille : choisis une autre couleur ou une autre taille.' : 'Désolé, on n’a pas pu ajouter ton pack. Réessaie dans un instant.');
        });
    }
    // Interception sur WINDOW en phase de capture : elle précède le délégué du thème (component.js écoute `submit` et `click` sur document, en
    // capture) ; stopPropagation ⇒ le thème ne voit ni l'envoi ni le clic d'un pack. 1 pull sans sac, taille choisie : rien n'est touché, le thème
    // ajoute au panier ; taille du pull 1 pas encore choisie : retenu, quel que soit le chemin.
    window.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      var n = offre(), sac = sacCoche();
      if (DZ.chemin(n, sac) === 'natif' && t1) return;
      e.preventDefault(); e.stopPropagation();
      if (!occupe) commander(n, sac);
    }, true);
    // Clic sur le bouton natif en mode pack ou sans taille du pull 1 : le thème n'anime pas « ajouté au panier » ; l'envoi natif du formulaire a quand
    // même lieu (retenu ci-dessus). La barre fixe du thème clique le bouton natif PUIS anime son propre « ajouté » : sans taille du pull 1, son clic est
    // retenu ici et la taille demandée directement.
    window.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[ref="addToCartButton"]') : null, n, sac;
      if (!t) return;
      n = offre(); sac = sacCoche();
      if (t !== btn) {
        if (t1 || !t.closest('sticky-add-to-cart')) return;
        e.preventDefault(); e.stopPropagation();
        if (!occupe) commander(n, sac);
        return;
      }
      if (DZ.chemin(n, sac) === 'natif' && t1) return;
      e.stopPropagation();
    }, true);
    // Bouton Releasit (dans la fiche ou flottant) : il commande la SEULE variante du formulaire natif. Taille du pull 1 pas encore choisie ⇒ retenu,
    // la taille est demandée ; pack (≥ 2 pulls ou sac) ⇒ le pack prend son chemin, jamais une commande Releasit d'un seul pull ; 1 pull sans sac,
    // taille choisie ⇒ rien n'est touché, Releasit ouvre son formulaire. Son bouton du panier (#cart-wrapper, tiroir) commande le panier : jamais touché.
    window.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest(DZ.RSI) : null, n, sac;
      if (!t || t.closest('#cart-wrapper, cart-drawer-component')) return;
      n = offre(); sac = sacCoche();
      if (DZ.chemin(n, sac) === 'natif' && t1) return;
      e.preventDefault(); e.stopPropagation();
      if (!occupe) commander(n, sac);
    }, true);

    // Pulls 2 et 3 : une taille épuisée dans la couleur choisie se dit, jamais en silence.
    if (pulls) {
      pulls.addEventListener('change', function (e) {
        var r = e.target, m = r && r.name && /^dz-(\d)-(couleur|taille)$/.exec(r.name);
        if (!m) return;
        var k = +m[1], s;
        cocher(r, true);
        radios(k, m[2]).forEach(function (x) { if (x !== r) x.setAttribute('data-current-checked', 'false'); });
        s = sel(k); note(k, ''); pull(k).classList.remove('dz-pull--manque');
        if (m[2] === 'couleur' && s.t && !dispo(s.c, s.t)) { note(k, s.t + ' est épuisé en ' + s.c + ' : choisis une autre taille ou une autre couleur.'); radios(k, 'taille').forEach(function (x) { cocher(x, false); }); }
        if (m[2] === 'taille' && s.c && !dispo(s.c, s.t)) { note(k, s.t + ' est épuisé en ' + s.c + ' : choisis une autre taille ou une autre couleur.'); cocher(r, false); }
        majDispo(k);
      });
    }
    root.querySelectorAll('input[name="dz-offre"]').forEach(function (r) { r.addEventListener('change', total); });
    var sac = recap && recap.querySelector('input[name="dz-sac"]'); if (sac) sac.addEventListener('change', total);
    // Le thème re-rend la barre fixe à chaque changement de variante : le libellé est reposé après son rendu.
    document.addEventListener('variant:update', function () { setTimeout(etiquette, 0); });
    // Retour arrière depuis le checkout (page restaurée par le navigateur pendant l'envoi) : le bouton redevient cliquable.
    window.addEventListener('pageshow', function (e) { if (e.persisted && occupe) occuper(false); });

    // Calculateur (bloc dz-tailles, rendu seulement avec une grille custom.guide_tailles) : la taille conseillée est posée sur le pull 1 (clic sur l'option du
    // sélecteur natif ⇒ le thème met la variante à jour) et sur les pulls 2 / 3 visibles ; une taille épuisée dans la couleur choisie se dit.
    if (tailles) {
      var gEl = tailles.querySelector('.dz-guide-data'), guide = null;
      try { guide = gEl ? JSON.parse(gEl.textContent) : null; } catch (e) { guide = null; }
      var ih = tailles.querySelector('input[name="dz-h"]'), iw = tailles.querySelector('input[name="dz-w"]'), out = tailles.querySelector('.dz-guide-r'), minuterie = null;
      function appliquer(t) {
        var faits = 0, rates = [], v1 = sel1(), fs = DZ.fieldsetParNom(picker, NOM_T), r, selN, k, s, rk;
        if (fs) {
          r = radioParValeur(fs, t);
          if (r && r.getAttribute('data-option-available') !== 'false') { if (!r.checked) r.click(); choisirT1(); faits++; }
          else rates.push('pull 1 (' + (v1 ? v1[oc] : 'couleur choisie') + ')');
        } else if (picker && NOM_T) {
          selN = picker.querySelector('select[name="options[' + NOM_T + ']"]');
          if (selN) { selN.value = t; selN.dispatchEvent(new Event('change', { bubbles: true })); faits++; }
        }
        for (k = 2; k <= offre(); k++) {
          s = sel(k); rk = radioParValeur(pull(k), t);
          if (!rk || rk.name !== 'dz-' + k + '-taille') continue;
          if (s.c && !dispo(s.c, t)) { radios(k, 'taille').forEach(function (x) { cocher(x, false); }); note(k, t + ' est épuisé en ' + s.c + ' : choisis une autre couleur pour ce pull.'); rates.push('pull ' + k + ' (' + s.c + ')'); }
          else { radios(k, 'taille').forEach(function (x) { cocher(x, x === rk); }); note(k, ''); faits++; }
          majDispo(k);
        }
        return { faits: faits, rates: rates };
      }
      function lire() {
        if (!out) return;
        var h = ih ? DZ.hauteur(ih.value) : NaN, w = iw ? DZ.nombre(iw.value) : NaN;
        if (!(h >= 130 && h <= 215)) h = NaN;
        if (!(w >= 35 && w <= 180)) w = NaN;
        out.textContent = ''; out.removeAttribute('data-taille');
        if ((!ih || isNaN(h)) && (!iw || isNaN(w))) return;
        if (ih && isNaN(h)) { out.textContent = 'Entre aussi ta taille en cm (ex. 178).'; return; }
        if (iw && isNaN(w)) { out.textContent = 'Entre aussi ton poids en kg (ex. 75).'; return; }
        var r = DZ.conseil(guide, h, w);
        if (r.etat === 'hors_grille') { out.textContent = 'Notre plus grande taille est le ' + r.taille + (tailles.querySelector('#dz-mesures') ? ' : regarde les mesures du pull avant de commander.' : ' : il risque d’être juste pour toi.'); return; }
        if (r.etat !== 'ok') return;
        // la pastille (taille en grand) est le ::before de data-taille : le texte lu reste « Prends M pour … ».
        var tx = document.createElement('span'); tx.className = 'dz-guide-txt'; out.appendChild(tx); out.setAttribute('data-taille', r.taille);
        var b = document.createElement('b'); b.textContent = 'Prends ' + r.taille;
        tx.appendChild(b); tx.appendChild(document.createTextNode(' pour ' + (ih ? h + ' cm' : '') + (ih && iw ? ' et ' : '') + (iw ? w + ' kg' : '') + '.'));
        var res = appliquer(r.taille), ok = document.createElement('span'); ok.className = 'dz-ok';
        ok.textContent = res.faits ? '✓ Taille ' + r.taille + ' choisie' + (res.rates.length ? ', sauf ' + res.rates.join(' et ') + ' où elle est épuisée.' : ' — tu peux encore la changer.') : r.taille + ' est épuisé dans la couleur choisie : choisis une autre couleur.';
        tx.appendChild(ok);
        if (r.plus_long) { var lg = document.createElement('span'); lg.className = 'dz-ok'; lg.textContent = 'Tu es grand : prends ' + r.plus_long + ' si tu veux des manches plus longues.'; tx.appendChild(lg); }
      }
      [ih, iw].forEach(function (el) { if (el) el.addEventListener('input', function () { clearTimeout(minuterie); minuterie = setTimeout(lire, 450); }); });
    }

    preselection();
    for (var k = 2; k <= 3; k++) if (pull(k)) majDispo(k);
    total();
    DZ.pret = true;
  }
  DZ.init = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
